angular.module('homebot.services')

.factory('ScrollService', ['$rootScope', function($rootScope){
  return {
    subscribe: function(scope, callback){
      const handler = $rootScope.$on('scroll-event', (e, data) => {
        callback(e, data);
      });

      scope.$on('$destroy', handler);
    },

    scroll: function(data){
      $rootScope.$emit('scroll-event', data);
    }
  }
}]);
